import { useTheme } from '../context/ThemeContext'

function KPICard({ title, value, unit, subtitle, trend, delta, onClick }) {
    const { theme } = useTheme()

    const effectiveTrend = delta != null ? (delta >= 0 ? 'up' : 'down') : trend
    const showDelta = delta != null && isFinite(delta)

    const Wrapper = onClick ? 'button' : 'div'
    const wrapperProps = onClick
        ? { onClick, className: 'drill-card text-left w-full' }
        : { className: 'kpi-card !p-4 sm:!p-6' }

    return (
        <Wrapper {...wrapperProps}>
            <div className="flex justify-between items-start">
                <p className="kpi-card-title !text-[10px] sm:!text-sm">{title}</p>
                {effectiveTrend && (
                    <span
                        className={`inline-flex items-center px-1.5 sm:px-2 py-0.5 rounded text-[10px] sm:text-xs font-medium ${
                            effectiveTrend === 'up'
                                ? theme === 'dark' ? 'bg-green-900 text-green-200' : 'bg-green-100 text-green-800'
                                : theme === 'dark' ? 'bg-red-900 text-red-200' : 'bg-red-100 text-red-800'
                        }`}
                    >
                        {effectiveTrend === 'up' ? (
                            <svg className="w-2.5 h-2.5 sm:w-3 sm:h-3 mr-0.5 sm:mr-1" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
                            </svg>
                        ) : (
                            <svg className="w-2.5 h-2.5 sm:w-3 sm:h-3 mr-0.5 sm:mr-1" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                        )}
                        {showDelta
                            ? `${delta >= 0 ? '+' : ''}${delta.toFixed(1)}%`
                            : <span className="hidden sm:inline">{effectiveTrend === 'up' ? 'Up' : 'Down'}</span>
                        }
                    </span>
                )}
            </div>
            <div className="kpi-card-value !text-xl sm:!text-3xl">
                {value}
                {unit && (
                    <span className={`text-sm sm:text-lg font-normal ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'} ml-1`}>
                        {unit}
                    </span>
                )}
            </div>
            {subtitle && <p className="kpi-card-subtitle !text-[10px] sm:!text-sm">{subtitle}</p>}
            {onClick && (
                <p className={`text-[10px] mt-2 ${theme === 'dark' ? 'text-blue-400' : 'text-blue-600'}`}>
                    Click for details &rarr;
                </p>
            )}
        </Wrapper>
    )
}

export default KPICard
